<template>
  <section
    id="features"
    class="bg-offwhite w-100 z-0">
    <div class="center flex-l greyhound justify-end pb5 pt4 pt6-xl w-100">
      <div class="b--tan bl center-m ph3 w-100 w-80-m w-60-l w-50-xl">
        <h2 class="f2 fw3">Power &amp; Performance</h2>
        <p class="dark-tan lh-copy w-100 w-80-xl">With easily-customizable features, the Pico 43”, 49”, and 55” 4K Ultra HD coffee table displays have a sleek design and precise, non-optical multitouch input that is both fast and reliable. This is the same projected-capacitive touch technology found in popular smartphones and tablets.</p>
        <img
          data-src="/images/pico-cutout-01.png"
          alt="A three-quarter view of the Pico multitouch table."
          class="lazyload">
      </div>
      <div class="center-m ph3 w-100 w-80-m w-40-l">
        <h3 class="f6 mb3 mt4 tracked tc tl-l ttu">Features</h3>
        <!-- features lists -->
        <div class="pt3">
          <h4
            class="dib f3 fw3 hover-gold link mt0 mb2 mr4 pointer"
            :class="{ 'bd': isStandard }"
            @click="isStandard = true">
            Standard
          </h4>
          <h4
            class="dib f3 fw3 hover-gold link mt0 mb2 pointer"
            :class="{ 'bd': !isStandard }"
            @click="isStandard = false">
            Peformance
          </h4>
          <transition
            name="fade"
            mode="out-in">
            <ul
              v-if="isStandard"
              key="standard"
              class="dark-tan f5 pl3 pl4-l lh-double">
              <li>8th Gen Intel® Core<sup class="super">TM</sup> i5-8400 processor</li>
              <li>GTX 1070 8GB DDR5 NVIDIA graphics card</li>
              <li>250GB NVMe M.2</li>
              <li>16GB 2400MHz DDR4 RAM</li>
            </ul>
            <ul
              v-else
              key="perf"
              class="dark-tan f5 pl3 pl4-l lh-double">
              <li>8th Gen Intel® Core<sup class="super">TM</sup> i7-8700 processor</li>
              <li>GTX 1080 8GB DDR5X NVIDIA graphics card</li>
              <li>Dual 250GB NVMe M.2 SSD in RAID 0</li>
              <li>32GB 2400MHz DDR4 RAM</li>
            </ul>
          </transition>

          <h4 class="f3 fw3 mb2">Touch Display</h4>
          <ul class="dark-tan f5 pl3 pl4-l lh-double">
            <li>3M<sup class="super">TM</sup> projected-capacitive touch screen</li>
            <li>4K UHD (3840x2160) LCD display</li>
            <li>80 touch points with palm rejection</li>
            <li>43”, 49” or 55” diagonal, strengthened, anti-stiction, 4mm glass surface</li>
          </ul>

          <h4 class="f3 fw3 mb2">Integrated PC System</h4>
          <ul class="dark-tan f5 pl3 pl4-l lh-double mb5">
            <li>Single push-button power</li>
            <li>Custom lockable enclosure</li>
            <li>Windows 10 (default), 8.1, or 7</li>
            <li>Universal 110-240V power system</li>
          </ul>
        </div>
        <!-- spec sheet download -->
        <div class="flex justify-center justify-start-l">
          <a
            href="https://ideum.com/spec-sheets/Ideum-Specs-Pico.pdf"
            target="_blank"
            rel="noopener">
            <app-button
              id="specs">
              View Spec Sheets
            </app-button>
          </a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import AppButton from '@/components/AppButton'

export default {
  name: 'SectionFeatures',

  components: {
    AppButton
  },

  data () {
    return {
      isStandard: true
    }
  }
}
</script>

<style lang="scss" scoped>
h3 {
  position: relative;
  @media screen and (min-width: 60em) {
    padding-left: 6rem;
    &::before {
      background-color: var(--tan);
      content: '';
      margin: auto;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      width: 5rem;
      height: 1px;
    }
  }
}

img {
  @media screen and (min-width: 100em) {
    transform: translateX(-4rem);
  }
}

section {
  position: relative;
  &::before {
    background-color: var(--tan);
    content: '';
    position: absolute;
    top: 57vh;
    left: 0;
    transition: all .3s var(--ease-cubic);
    width: 88%;
    height: 150px;
    z-index: -1;
    @media screen and (min-width: 30em) and (max-width: 60em) {
      top: 23rem;
      width: 83%;
      height: 225px;
    }
    @media screen and (min-width: 60em) {
      top: 26rem;
      width: 59%;
      height: 210px;
    }
    @media screen and (min-width: 100em) {
      top: 36rem;
      width: 59%;
      height: 339px;
    }
  }
}
</style>
